import React, { useState } from 'react';
import { Button } from '@utahdts/utah-design-system';
import { appConfig } from '../../configuration/AppConfig';

/**
 * PDFDownloadButton
 * 
 * Allows users to download the water monitoring report as a PDF
 * Calls the Lambda function to generate PDF via Puppeteer
 */
const PDFDownloadButton = ({ reportId, filename = 'report.pdf', disabled = false, printableUrl, footer }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleDownloadPDF = async () => {
    setLoading(true);
    setError(null);

    try {
      // Call the PDF generation service
      const response = await fetch(appConfig.pdfGeneratorUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          url: printableUrl,
          filename: filename,
          options: {
            format: 'Letter',
            printBackground: true,
            // waitForSelector: '.report-content',
            margin: {
              top: '40px',
              bottom: '70px',
              left: '0px',
              right: '0px',
            },
          },
          ...(footer && {
            footer: {
              text: footer.text
            }
          })
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const contentType = response.headers.get('content-type');
      const contentLength = response.headers.get('content-length');
      console.log('PDF Response Headers:', { contentType, contentLength });

      // Convert response to blob
      const blob = await response.blob();

      // Create download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;

      // Trigger download
      document.body.appendChild(link);
      link.click();

      // Cleanup
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Error downloading PDF:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="utah-design-system">
      <Button
        onClick={handleDownloadPDF}
        disabled={disabled || loading || !printableUrl}
        iconRight={<span className="utds-icon-after-download icon" aria-hidden="true" />}
      >
        {loading ? 'Generating PDF...' : 'Download PDF Report'}
      </Button>
      {error && (
        <p className="pdf-error" style={{ color: 'red', marginTop: '0.5rem' }}>
          {error}
        </p>
      )}
    </div>
  );
};

export default PDFDownloadButton;
